// The kinds of document a vendor can have on file, in one list (release 3.2,
// removal items 13 and 14).
//
// Two upload forms wrote the same table with two label sets ("Master
// agreement" and "Master services agreement", "CERT-In audit report" and
// "CERT-In empanelled audit"), so a reader could not tell the same kind apart.
// The values are the API's (the CHECK on vendor_documents.doc_type).

export const DOC_TYPES: { value: string; label: string }[] = [
  { value: 'MSA', label: 'Master services agreement' },
  { value: 'SOW', label: 'Statement of work' },
  { value: 'DPA', label: 'Data processing agreement' },
  { value: 'NDA', label: 'Non-disclosure agreement' },
  { value: 'ISO27001', label: 'ISO/IEC 27001 certificate' },
  { value: 'ISO27701', label: 'ISO/IEC 27701 certificate' },
  { value: 'SOC2', label: 'SOC 2 report' },
  { value: 'PCI_DSS', label: 'PCI DSS attestation' },
  { value: 'CERTIN_AUDIT', label: 'CERT-In empanelled audit' },
  { value: 'INSURANCE', label: 'Insurance certificate' },
  { value: 'OTHER', label: 'Other' },
]

export const DOC_TYPE_LABEL: Record<string, string> = Object.fromEntries(DOC_TYPES.map((t) => [t.value, t.label]))

export function docTypeWords(code: string): string {
  return DOC_TYPE_LABEL[code] ?? 'Other document'
}

// The kinds that set the contract's dates: their In force from and Expires on
// are the vendor's contract start and end.
export const CONTRACT_KINDS = new Set(['MSA', 'SOW'])

// The agreements (repo.ContractDocumentKinds on the server): their "In force
// from" may lie ahead. Every other kind is a certificate or a report, whose
// issue date has already happened (date rule D7).
export const AGREEMENT_KINDS = new Set(['MSA', 'SOW', 'DPA', 'NDA'])
